import { render } from "./DataTableWithFilters.vue?vue&type=template&id=0c20c3da&scoped=true"
import script from "./DataTableWithFilters.vue?vue&type=script&lang=js"
export * from "./DataTableWithFilters.vue?vue&type=script&lang=js"

import "./DataTableWithFilters.vue?vue&type=style&index=0&id=0c20c3da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c20c3da"]])

export default __exports__